import AppRouter from './router';
import './App.css';

const App = () => {
  return <AppRouter />;
};

export default App;
